<!-- <div id="elmLoader" >
    <div class="spinner-border text-primary avatar-sm" role="marketverviewChart">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div> -->
  <!-- <div id="elmLoader text-center position-relative"  style="z-index: 99999;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="text-black">Loading...</span>
    </div>
</div> -->
<!-- <div >
  <div class="heartbeatloader">
      <svg class="svgdraw" width="100%" height="100%" viewBox="0 0 150 400" xmlns="http://www.w3.org/2000/svg" >
          <path class="path" d="M 0 200 l 40 0 l 5 -40 l 5 40 l 10 0 l 5 15 l 10 -140 l 10 220 l 5 -95 l 10 0 l 5 20 l 5 -20 l 30 0" fill="transparent" stroke-width="4" stroke="black"/>
      </svg>
      <div class="innercircle"></div>
      <div class="outercircle"></div>
  </div>
</div>  -->

<div id="overlay">
  <div class="heartbeatloader">
      <div class="loadingio-spinner-spin-jooltp4miz"><div class="ldio-nuj4gp8ob9r">
          <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
          </div></div>
  </div>
</div> 

